// Composables
import { getEnv } from '@/composables/helpers/getEnv';
import { getModelFromSlug } from '@/composables/builder';
import { filterScheduledPosts } from '../data/filterScheduledPosts';

export const getPageContent = async (route, model = 'page') => {
    const BUILDER_API = getEnv('builderApi');
    const BUILDER_ENV = getEnv('builderEnv');
    const PRODUCTION_CACHE = getEnv('productionCache') || 0;

    const cleanURL = route.split('?')[0];

    model = getModelFromSlug(cleanURL);
    // Fetch page content options
    let cacheSeconds = 0;
    let includeUnpublished = true;
    const isPreview = route.includes('builder.space=');

    if (BUILDER_ENV === 'Production' && !isPreview) {
        // cacheSeconds = 15 * 60;
        cacheSeconds = PRODUCTION_CACHE;
        includeUnpublished = false;
    }

    const userAttributes = {
        urlPath: cleanURL,
    };

    let query = {
        data: {
            environment: BUILDER_ENV,
        },
    };

    // Convert to query strings
    const convertObjectToQueryString = (obj, nestedKeys = '') => {
        const keys = Object.keys(obj);
        if (keys.length === 0) return '';

        let strings = [];

        for (const key of keys) {
            if (typeof obj[key] === 'object') {
                const deeplyNestedStrings = convertObjectToQueryString(obj[key], nestedKeys + key + '.');
                strings = [...strings, ...deeplyNestedStrings];
            } else {
                const value = `${nestedKeys + key}__||__${obj[key]}`;
                strings.push(value);
            }
        }

        return strings;
    };

    const queryString = convertObjectToQueryString(query, 'query.');

    // query = query ? `?query=${JSON.stringify(query)}` : '';

    const now = new Date().getTime();
    const params = {
        apiKey: BUILDER_API,
        userAttributes,
        includeUnpublished: true,
        cacheSeconds,
        'query.$or': [{ endDate: { $gte: now } }, { endDate: { $exists: false } }, { endDate: { $eq: null } }],
    };

    queryString.forEach((string) => {
        const split = string.split('__||__');
        params[split[0]] = split[1];
    });

    const BuilderPageAPIResponse = await $fetch(`https://cdn.builder.io/api/v3/content/${model}`, {
        method: 'GET',
        params,
    });

    // If start date is in the future remove it
    const filteredResults = BuilderPageAPIResponse.results.filter((item) => {
        if (item.startDate) {
            return item.startDate <= now;
        }
        return true;
    });
    BuilderPageAPIResponse.results = filteredResults;

    // If there are more than one result, sort the one with the newest start date
    const sortedResults = BuilderPageAPIResponse.results.sort((a, b) => {
        return b.startDate - a.startDate;
    });
    BuilderPageAPIResponse.results = sortedResults;
    if (model == 'community' && !BuilderPageAPIResponse.results[0].data.createIndexPage) {
        throw createError({
            statusCode: 404,
            statusMessage: 'Page Not Found: Community not found.',
            fatal: true,
        });
    }
    return {
        content: BuilderPageAPIResponse.results[0],
        api: BUILDER_API,
        model,
    };
};

export const getBlogPosts = async (params) => {
    const BUILDER_API = getEnv('builderApi');
    const BUILDER_ENV = getEnv('builderEnv');
    const PRODUCTION_CACHE = getEnv('productionCache') || 0;
    // TODO: Enable when go live with the blog
    // const cacheSeconds = 15 * 60;
    const cacheSeconds = PRODUCTION_CACHE;

    const BuilderBlogAPIResponse = await $fetch('https://cdn.builder.io/api/v3/content/blog', {
        method: 'GET',
        params: {
            apiKey: BUILDER_API,
            'query.data.environment': BUILDER_ENV,
            limit: params.limit,
            offset: params?.offset,
            cacheSeconds,
            fields: ['data', 'startDate', 'endDate'],
            'sort.data.datePublished': -1,
        },
    });
    let result = BuilderBlogAPIResponse.results;
    result = filterScheduledPosts(result);

    return result;
};

export const getCommunityPosts = async (params) => {
    const BUILDER_API = getEnv('builderApi');
    const BUILDER_ENV = getEnv('builderEnv');
    const PRODUCTION_CACHE = getEnv('productionCache') || 0;
    // TODO: Enable when go live with the blog
    // const cacheSeconds = 15 * 60;
    const cacheSeconds = PRODUCTION_CACHE;

    const BuilderCommunityAPIResponse = await $fetch('https://cdn.builder.io/api/v3/content/community', {
        method: 'GET',
        params: {
            apiKey: BUILDER_API,
            'query.data.environment': BUILDER_ENV,
            limit: params.limit,
            cacheSeconds,
            fields: ['data'],
        },
    });
    let result = BuilderCommunityAPIResponse.results;

    return result;
};

export const getCommunityPostsRandom = async (params) => {
    const BUILDER_API = getEnv('builderApi');
    const BUILDER_ENV = getEnv('builderEnv');
    const PRODUCTION_CACHE = getEnv('productionCache') || 0;

    const cacheSeconds = PRODUCTION_CACHE;
    let relatedCommunityPosts = [];
    const randomPostIds = [];
    const requiredPosts = 3 - params.relatedPostIds?.length;
    const exclude = params.exclude;

    const selectedPosts = (
        await $fetch('https://cdn.builder.io/api/v3/content/community', {
            method: 'GET',
            params: {
                apiKey: BUILDER_API,
                'query.data.environment': BUILDER_ENV,
                limit: 1,
                cacheSeconds: 0,
                staleCacheSeconds: 0,
                'query.id.$in': [params.relatedPostIds],
                includeUnpublished: false,
            },
        })
    ).results;
    //  console.log(params.relatedPostIds);
    if (params.relatedPostIds?.length < 3) {
        const communityPostIds = (
            await $fetch('https://cdn.builder.io/api/v3/content/community', {
                method: 'GET',
                params: {
                    apiKey: BUILDER_API,
                    'query.data.environment': BUILDER_ENV,
                    limit: 50,
                    cacheSeconds: 0,
                    staleCacheSeconds: 0,
                    'query.id.$nin': [params.exclude, ...params.relatedPostIds, 0],
                    includeUnpublished: false,
                },
            })
        ).results;
        const result = selectedPosts;
        const usedIndex = [];
        while (result?.length < 3) {
            const randomIndex = Math.floor(Math.random() * communityPostIds?.length);
            //  console.log('used so far', usedIndex);
            //  console.log('current random', randomIndex);
            //  console.log('used check', !usedIndex.includes(randomIndex));
            if (!usedIndex.includes(randomIndex)) {
                usedIndex.push(randomIndex);
                result.push(communityPostIds[randomIndex]);
            }
        }
    }
    return selectedPosts;
};

export const getRegistrationData = async () => {
    const BUILDER_API = getEnv('builderApi');
    const BUILDER_ENV = getEnv('builderEnv');
    const DATA_ENV = getEnv('dataEnv') || BUILDER_ENV;
    const PRODUCTION_CACHE = getEnv('productionCache') || 0;

    const cacheSeconds = PRODUCTION_CACHE;

    const registrationData = (
        await $fetch('https://cdn.builder.io/api/v3/content/registration-data', {
            method: 'GET',
            params: {
                apiKey: BUILDER_API,
                'query.data.environment': BUILDER_ENV,
                cacheSeconds,
            },
        })
    )?.results[0];

    return registrationData;
};

export const getFeaturedBlogPosts = async (params) => {
    const BUILDER_API = getEnv('builderApi');
    const BUILDER_ENV = getEnv('builderEnv');
    const DATA_ENV = getEnv('dataEnv') || BUILDER_ENV;
    const PRODUCTION_CACHE = getEnv('productionCache') || 0;

    const cacheSeconds = PRODUCTION_CACHE;

    // TODO: Combine these two queries into one

    const featuredBlogPost = (
        await $fetch('https://cdn.builder.io/api/v3/content/blog', {
            method: 'GET',
            params: {
                apiKey: BUILDER_API,
                'query.data.environment': BUILDER_ENV,
                limit: 1,
                cacheSeconds,
                fields: ['data', 'startDate', 'endDate'],
                'sort.data.datePublished': -1,
                'query.data.featured.$eq': true,
            },
        })
    )?.results[0];

    const latestBlogPost = (
        await $fetch('https://cdn.builder.io/api/v3/content/blog', {
            method: 'GET',
            params: {
                apiKey: BUILDER_API,
                'query.data.environment': BUILDER_ENV,
                limit: 5,
                cacheSeconds,
                fields: ['data', 'startDate', 'endDate'],
                'sort.data.datePublished': -1,
                'query.data.featured.$not': true,
            },
        })
    )?.results;
    let result;
    if (featuredBlogPost) {
        result = [featuredBlogPost, ...latestBlogPost];
        result = filterScheduledPosts(result);
        return result;
    }

    return filterScheduledPosts(latestBlogPost);
};

export const getRelatedBlogPosts = async (params) => {
    const BUILDER_API = getEnv('builderApi');
    const BUILDER_ENV = getEnv('builderEnv');
    const DATA_ENV = getEnv('dataEnv') || BUILDER_ENV;
    const PRODUCTION_CACHE = getEnv('productionCache') || 0;

    const cacheSeconds = PRODUCTION_CACHE;

    let relatedBlogPosts = [];
    let relatedBlogPostsByCategory = [];
    //  console.log(params);
    // TODO: Figure out how to combine these two queries into one and exclude the current post
    if (params.relatedPostsIds.length) {
        relatedBlogPosts = (
            await $fetch('https://cdn.builder.io/api/v3/content/blog', {
                method: 'GET',
                params: {
                    apiKey: BUILDER_API,
                    'query.data.environment': BUILDER_ENV,
                    limit: params.limit,
                    cacheSeconds,
                    'sort.data.datePublished': -1,
                    'query.id.$in': [params.relatedPostsIds],
                    includeUnpublished: false,
                },
            })
        ).results;
    }

    relatedBlogPostsByCategory = (
        await $fetch('https://cdn.builder.io/api/v3/content/blog', {
            method: 'GET',
            params: {
                apiKey: BUILDER_API,
                'query.data.environment': BUILDER_ENV,
                limit: params.limit,
                cacheSeconds,
                'sort.data.datePublished': -1,
                'query.data.category.$eq': params.category,
                includeUnpublished: false,
            },
        })
    ).results;

    let result = new Set([...relatedBlogPosts, ...relatedBlogPostsByCategory]);
    if (params.exclude) {
        result.forEach((post) => {
            if (params.exclude.includes(post.id)) {
                result.delete(post);
            }
        });
    }
    result = Array.from(result);
    result = filterScheduledPosts(result);

    return result;
};

export const getBlogPostsByIds = async (ids) => {
    const BUILDER_API = getEnv('builderApi');
    const BUILDER_ENV = getEnv('builderEnv');
    const DATA_ENV = getEnv('dataEnv') || BUILDER_ENV;
    const PRODUCTION_CACHE = getEnv('productionCache') || 0;

    const cacheSeconds = PRODUCTION_CACHE;

    const BuilderBlogAPIResponse = await $fetch('https://cdn.builder.io/api/v3/content/blog', {
        method: 'GET',
        params: {
            apiKey: BUILDER_API,
            'query.data.environment': BUILDER_ENV,
            cacheSeconds,
            fields: ['data', 'startDate', 'endDate'],
            'query.id.$in': ids,
        },
    });

    let result = BuilderBlogAPIResponse.results;
    result = filterScheduledPosts(result);

    return result;
};

export const getAuthor = async (authorId) => {
    const BUILDER_API = getEnv('builderApi');
    const BUILDER_ENV = getEnv('builderEnv');
    const PRODUCTION_CACHE = getEnv('productionCache') || 0; // Default to 0 if not set

    const cacheSeconds = PRODUCTION_CACHE;

    const BuilderAuthorAPIResponse = await $fetch(`https://cdn.builder.io/api/v3/content/author/${authorId}`, {
        method: 'GET',
        params: {
            apiKey: BUILDER_API,
            'query.data.environment': BUILDER_ENV,
            cacheSeconds,
        },
    });

    return BuilderAuthorAPIResponse;
};
